import { axiosPrivate } from 'shared/api';
import { ILogs } from 'features/settings/history/types';
import { BaseService } from 'shared/services/BaseService';

class LogService extends BaseService<ILogs> {
  constructor() {
    super('auditlogs');
  }
  canBulkDelete = true;

  getModels = async () => {
    const res = await axiosPrivate.get(`${this.modulePrefix}/models/`);
    return res.data;
  };

  getVersions = async (
    model: string,
    object_id: string,
    fields: Record<string, string>,
    pagination?: { limit?: number; offset?: number },
    extra?: { action?: string | number; actor_name?: string }
  ) => {
    const res = await axiosPrivate.post(`${this.modulePrefix}/get_versions/`, {
      model,
      object_id,
      fields,
      action: extra?.action,
      ...(extra?.actor_name?.trim() ? { actor_name: extra.actor_name.trim() } : {}),
      limit: pagination?.limit,
      offset: pagination?.offset
    });
    return res.data;
  };

  getVersionsByActor = async (
    actorName: string,
    pagination?: { limit?: number; offset?: number }
  ) => {
    const res = await axiosPrivate.post(`${this.modulePrefix}/get_versions/`, {
      actor_name: actorName,
      limit: pagination?.limit,
      offset: pagination?.offset
    });
    return res.data;
  };

  restoreDeletedObject = async (id: number) => {
    const res = await axiosPrivate.post(`${this.modulePrefix}/restore_deleted_object/`, { id });
    return res.data;
  };
}

export const logService = new LogService();
